import { firestore } from "vue-app-utils-web";
import dbFns from "@/db-functions-VITE_APP_PLATFORM";

const db = firestore();

export { db, dbFns };
